import React, {Fragment} from 'react';
import Select from '../../form/Select';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import DateTimeInput from "../../form/DateTimeInput";

class FranchiseClearingForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-md-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="franchisor"
                            labelKey="name"
                            storeType="local"
                            label={<Fragment>&nbsp;</Fragment>}
                            disabled={true}
                            filter={[{field: "id", value: 1}]}
                            autoSelect={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="franchisee"
                            label="Franchise Partner"
                            labelKey="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-6">
                                <DateTimeInput
                                    name="startdate"
                                    value={this.props.values.startdate}
                                    label="Kezdő dátum"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("startdate")}
                                />
                            </div>
                            <div className="col-md-6">
                                <DateTimeInput
                                    name="enddate"
                                    value={this.props.values.enddate}
                                    label="Vég dátum"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("enddate")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(FranchiseClearingForm);
